import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { formatLedgerAmount } from "@/pages/admin/purchases/purchaseHelpers";

// Company General Ledger — every stock/payable movement across the whole business (Gold Stock,
// Gold/Cash Payable to Suppliers, Cash Paid Out, Purchases Expense), posted automatically.
export const CompanyLedgerDialog = ({ open, onClose, companyLedger }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="company-ledger-dialog" className="max-w-3xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Company General Ledger</DialogTitle>
        <DialogDescription>Automatically posted whenever a purchase, return, or payment happens — Gold Stock, Gold/Cash Payable to Suppliers, Cash Paid Out, and Purchases Expense.</DialogDescription>
      </DialogHeader>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {companyLedger.accounts.map((a) => (
          <div key={a.account} className="rounded-lg border border-border bg-card p-2.5">
            <div className="text-[10px] text-muted-foreground uppercase truncate">{a.label}</div>
            <div className={`font-mono text-lg ${a.balance < 0 ? "text-[#7A1F1F]" : ""}`}>{formatLedgerAmount(a.kind, a.balance)}</div>
          </div>
        ))}
        {companyLedger.accounts.length === 0 && <p className="text-xs text-muted-foreground col-span-3">No ledger activity yet — record a purchase to get started.</p>}
      </div>
      <div className="mt-3">
        <div className="text-sm font-medium mb-1">Recent Entries</div>
        <Table>
          <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Account</TableHead><TableHead>Description</TableHead><TableHead className="text-right">Debit</TableHead><TableHead className="text-right">Credit</TableHead></TableRow></TableHeader>
          <TableBody>
            {companyLedger.entries.slice(0, 100).map((e, idx) => (
              <TableRow key={e.id || `${e.ref_type}-${e.ref_id}-${e.account}-${idx}`}>
                <TableCell className="text-xs whitespace-nowrap">{(e.date || "").slice(0, 10)}</TableCell>
                <TableCell className="text-xs">{e.account.replace(/_/g, " ")}</TableCell>
                <TableCell className="text-xs">{e.description}</TableCell>
                <TableCell className="text-right font-mono text-xs">{e.debit ? formatLedgerAmount(e.kind, e.debit) : "—"}</TableCell>
                <TableCell className="text-right font-mono text-xs">{e.credit ? formatLedgerAmount(e.kind, e.credit) : "—"}</TableCell>
              </TableRow>
            ))}
            {companyLedger.entries.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-xs text-muted-foreground py-6">No entries yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </DialogContent>
  </Dialog>
);
